import classes from '../QuestionTrends.module.css';

type PillToggleProps<T extends string> = {
  label: string;
  options: Array<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
};

/** Knapper i en pille der én er valgt (aria-pressed) */
export const PillToggle = <T extends string>({ label, options, value, onChange }: PillToggleProps<T>) => (
  <div role="group" aria-label={label} className={classes.pills}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        aria-pressed={value === option.value}
        className={classes.pill}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);
